import { ArrowRight, Menu, X } from "react-feather";
import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";

import ClickAwayListener from "react-click-away-listener";
import { GifSend } from "../assets";
import MegaMenu from "./MegaMenu";
import Modal from "react-modal";
import ReactSelect from "react-select";
import emailjs from "@emailjs/browser";
import { megaMenuList } from "../data/megaMenuList";
import { useRef } from "react";

export default function Header({ isOnVerify }) {
  const [nameError, setNameError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [flavorError, setFlavorError] = useState("");
  const form = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isService, setIsService] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [megaMenuListUpdated, setMegaMenuListUpdated] = useState(megaMenuList);

  useEffect(() => {
    const updateList = () => {
      if (window.innerWidth < 1060) {
        setMegaMenuListUpdated([
          ...megaMenuList,
          {
            title: "Spotlight",
            link: "spotlight",
            children: [],
          },
        ]);
      }
      if (window.innerWidth >= 1060) {
        setMegaMenuListUpdated(megaMenuList);
      }
    };
    updateList();
    window.addEventListener("resize", updateList);
  }, []);

  const [serviceName, setServiceName] = useState(megaMenuListUpdated[0].title);

  useEffect(() => {
    setServiceName(megaMenuListUpdated[0].title);
  }, [megaMenuListUpdated]);

  const path = window.location.pathname;

  const handleNameChange = (e) => {
    if (e.target.value === "") {
      setNameError("Name is required");
    } else {
      setNameError("");
    }
  };
  const handleCountryChange = (e) => {
    if (e.target.value === "") {
      setCountryError("Country is required");
    } else {
      setCountryError("");
    }
  };
  const handleEmailChange = (e) => {
    if (e.target.value === "") {
      setEmailError("Email is required");
    } else {
      setEmailError("");
    }
  };
  const handleCompanyChange = (e) => {
    if (e.target.value === "") {
      setCompanyError("Company is required");
    } else {
      setCompanyError("");
    }
  };
  const handleTitleChange = (e) => {
    if (e.target.value === "") {
      setTitleError("Title is required");
    } else {
      setTitleError("");
    }
  };
  const handlePhoneChange = (e) => {
    if (e.target.value === "") {
      setPhoneError("Phone is required");
    } else {
      setPhoneError("");
    }
  };

  const handleCategoriesChange = (e) => {
    if (e.length === 0) {
      setCategoryError("Category is required");
    } else {
      setCategoryError("");
    }
  };

  const handleFlavorChange = (e) => {
    if (e.length === 0) {
      setFlavorError("Flavor is required");
    } else {
      setFlavorError("");
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_pxss1gf",
        "template_le9x0er",
        form.current,
        "7xAcUTkAwtio_EIZ8"
      )
      .then(() => {
        setIsModalOpen(true);
        setIsError(false);
      });
  };

  useEffect(() => {
    setIsService(false);
  }, [path]);

  useEffect(() => {
    if (isModalOpen) {
      const timer = setTimeout(() => {
        setIsModalOpen(false);
        setPopupVisible(false);
      }, 2500);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [isModalOpen]);

  const changeNavState = () => {
    if (window.innerWidth <= 1060) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };
  useEffect(() => {
    changeNavState();
    window.addEventListener("resize", () => {
      changeNavState();
      setIsService(false);
    });
    window.addEventListener("scroll", changeNavState);
  }, []);

  const handleOnClick = (name) => {
    if (window.innerWidth < 1060) {
      setIsOpen(false);
    }
    if (name !== undefined || name !== null) {
      setServiceName(name);
      setIsService(!isService);
    }
  };

  const handleOnHover = (name) => {
    if (window.innerWidth > 1060) {
      setServiceName(name);
      setIsService(true);
    }
  };

  return (
    <>
      <div className="header__content__nav__top__wrapper">
        <div className="mainheader__bar__top">
          <div className="mainheader__bar__top__heading">
          Welcome to Gulf Tech Repairing Service.<NavLink
              className="mainheader__bar__top__heading__navlink"
            
            >
              Learn More Here!
              <ArrowRight
                style={{
                  color: "#fff",
                  width: "20px",
                  height: "20px",
                }}
              />
            </NavLink>
            <NavLink
              className="mainheader__bar__top__heading__navlink__mobile"
              to="/who-we-are"
            >
              {" "}
              Learn More Here! →
            </NavLink>
          </div>
        </div>
      </div>
  
      <div
        onMouseLeave={() => {
          if (window.innerWidth > 1060) {
            setIsService(false);
          }
        }}
      >
        <div
          className={
            isOnVerify || isService ? "header header__active" : "header"
          }
          style={
            isOpen && window.innerWidth < 1060
              ? {
                  backgroundColor: "#0F77CC",
                }
              : {}
          }
        >
          <div className="header__content">
            <Link to="/" className="header__content__logo" title="Gulf Tech">
            <svg width="261" height="47" viewBox="0 0 261 47" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30.0626 18.839C30.3434 18.839 30.586 18.9411 30.7902 19.1453C30.9945 19.3496 31.0966 19.5921 31.0966 19.873V23.9324C31.0966 27.8131 29.769 30.698 27.1138 32.5873C24.4841 34.4511 20.9991 35.383 16.6589 35.383C12.3186 35.383 8.82091 34.4511 6.1657 32.5873C3.53603 30.698 2.22119 27.7875 2.22119 23.8558V19.3368C2.22119 16.7327 2.85946 14.5753 4.136 12.8647C5.41254 11.1286 7.13588 9.8521 9.306 9.03511C11.4761 8.21812 13.9271 7.80963 16.6589 7.80963C19.9268 7.80963 22.6203 8.34577 24.7394 9.41807C26.8585 10.4904 28.3903 11.7031 29.335 13.0562C30.3051 14.4094 30.7902 15.5072 30.7902 16.3497C30.7902 16.5795 30.7009 16.7837 30.5222 16.9624C30.369 17.1156 30.1775 17.1922 29.9477 17.1922H21.2927C20.7821 17.1922 20.4119 17.0518 20.1821 16.771C19.3907 15.7753 18.2163 15.2774 16.6589 15.2774C15.4845 15.2774 14.5015 15.5455 13.7101 16.0816C12.9441 16.6178 12.5612 17.3071 12.5612 18.1496V24.66C12.5612 25.6812 12.9441 26.4855 13.7101 27.0727C14.476 27.6343 15.4589 27.9152 16.6589 27.9152C18.2418 27.9152 19.4035 27.6471 20.1439 27.111C20.9098 26.5493 21.3055 25.8982 21.331 25.1579H18.9567C18.6758 25.1579 18.4333 25.0557 18.229 24.8515C18.0248 24.6472 17.9227 24.4047 17.9227 24.1239V19.873C17.9227 19.5921 18.0248 19.3496 18.229 19.1453C18.4333 18.9411 18.6758 18.839 18.9567 18.839H30.0626ZM48.8128 35.383C44.5236 35.383 41.1153 34.4511 38.5877 32.5873C36.0857 30.7236 34.8347 27.8131 34.8347 23.8558V9.22659C34.8347 8.94575 34.9368 8.70321 35.141 8.49896C35.3453 8.29471 35.5878 8.19259 35.8687 8.19259H43.8726C44.1534 8.19259 44.396 8.29471 44.6002 8.49896C44.8045 8.70321 44.9066 8.94575 44.9066 9.22659V24.4685C44.9066 25.5153 45.2513 26.3195 45.9406 26.8812C46.6555 27.4429 47.6129 27.7237 48.8128 27.7237C50.0128 27.7237 50.9574 27.4429 51.6467 26.8812C52.3616 26.3195 52.719 25.5153 52.719 24.4685V9.22659C52.719 8.94575 52.8212 8.70321 53.0254 8.49896C53.2297 8.29471 53.4722 8.19259 53.753 8.19259H61.757C62.0378 8.19259 62.2804 8.29471 62.4846 8.49896C62.6888 8.70321 62.791 8.94575 62.791 9.22659V23.8558C62.791 27.8131 61.5272 30.7236 58.9996 32.5873C56.4976 34.4511 53.102 35.383 48.8128 35.383ZM93.8343 27.1493C94.1152 27.1493 94.3577 27.2514 94.5619 27.4556C94.7662 27.6599 94.8683 27.9024 94.8683 28.1833V33.966C94.8683 34.2468 94.7662 34.4894 94.5619 34.6936C94.3577 34.8979 94.1152 35 93.8343 35H71.4693C71.1884 35 70.9459 34.8979 70.7416 34.6936C70.5374 34.4894 70.4353 34.2468 70.4353 33.966V9.22659C70.4353 8.94575 70.5374 8.70321 70.7416 8.49896C70.9459 8.29471 71.1884 8.19259 71.4693 8.19259H79.7413C80.0221 8.19259 80.2647 8.29471 80.4689 8.49896C80.6732 8.70321 80.7753 8.94575 80.7753 9.22659V27.1493H93.8343ZM126.831 8.19259C127.112 8.19259 127.354 8.29471 127.558 8.49896C127.763 8.70321 127.865 8.94575 127.865 9.22659V15.0476C127.865 15.3285 127.763 15.571 127.558 15.7753C127.354 15.9795 127.112 16.0816 126.831 16.0816H111.78V18.5326H124.342C124.622 18.5326 124.865 18.6347 125.069 18.839C125.273 19.0432 125.376 19.2858 125.376 19.5666V25.3493C125.376 25.6302 125.273 25.8727 125.069 26.077C124.865 26.2812 124.622 26.3833 124.342 26.3833H111.78V33.966C111.78 34.2468 111.678 34.4894 111.474 34.6936C111.27 34.8979 111.027 35 110.746 35H102.474C102.193 35 101.951 34.8979 101.747 34.6936C101.542 34.4894 101.44 34.2468 101.44 33.966V9.22659C101.44 8.94575 101.542 8.70321 101.747 8.49896C101.951 8.29471 102.193 8.19259 102.474 8.19259H126.831ZM159.636 8.19259C159.917 8.19259 160.159 8.29471 160.363 8.49896C160.568 8.70321 160.67 8.94575 160.67 9.22659V15.3923C160.67 15.6731 160.568 15.9157 160.363 16.1199C160.159 16.3242 159.917 16.4263 159.636 16.4263H151.402V33.966C151.402 34.2468 151.3 34.4894 151.096 34.6936C150.891 34.8979 150.649 35 150.368 35H142.479C142.198 35 141.956 34.8979 141.751 34.6936C141.547 34.4894 141.445 34.2468 141.445 33.966V16.4263H133.211C132.93 16.4263 132.688 16.3242 132.484 16.1199C132.279 15.9157 132.177 15.6731 132.177 15.3923V9.22659C132.177 8.94575 132.279 8.70321 132.484 8.49896C132.688 8.29471 132.93 8.19259 133.211 8.19259H159.636ZM191.368 27.5322C191.649 27.5322 191.892 27.6343 192.096 27.8386C192.3 28.0428 192.402 28.2854 192.402 28.5662V33.966C192.402 34.2468 192.3 34.4894 192.096 34.6936C191.892 34.8979 191.649 35 191.368 35H167.165C166.884 35 166.642 34.8979 166.438 34.6936C166.233 34.4894 166.131 34.2468 166.131 33.966V9.22659C166.131 8.94575 166.233 8.70321 166.438 8.49896C166.642 8.29471 166.884 8.19259 167.165 8.19259H190.985C191.266 8.19259 191.509 8.29471 191.713 8.49896C191.917 8.70321 192.019 8.94575 192.019 9.22659V14.6264C192.019 14.9072 191.917 15.1498 191.713 15.354C191.509 15.5582 191.266 15.6604 190.985 15.6604H176.088V18.073H188.879C189.16 18.073 189.403 18.1752 189.607 18.3794C189.811 18.5837 189.913 18.8262 189.913 19.107V24.0856C189.913 24.3664 189.811 24.6089 189.607 24.8132C189.403 25.0174 189.16 25.1196 188.879 25.1196H176.088V27.5322H191.368ZM207.974 24.66C207.974 25.7068 208.319 26.511 209.008 27.0727C209.723 27.6343 210.68 27.9152 211.88 27.9152C212.953 27.9152 213.744 27.7365 214.255 27.379C214.765 27.0216 215.199 26.4855 215.557 25.7706C215.889 25.1068 216.335 24.7749 216.897 24.7749H225.169C225.399 24.7749 225.59 24.8642 225.744 25.043C225.922 25.1961 226.012 25.3876 226.012 25.6174C226.012 27.1748 225.488 28.7066 224.441 30.213C223.395 31.6938 221.799 32.932 219.654 33.9277C217.535 34.8979 214.944 35.383 211.88 35.383C209.148 35.383 206.71 34.9745 204.566 34.1575C202.447 33.315 200.762 32.0384 199.511 30.3279C198.26 28.5918 197.634 26.4344 197.634 23.8558V19.3368C197.634 16.7582 198.26 14.6136 199.511 12.903C200.762 11.1669 202.447 9.89039 204.566 9.0734C206.71 8.23089 209.148 7.80963 211.88 7.80963C214.944 7.80963 217.535 8.30748 219.654 9.30318C221.799 10.2734 223.395 11.5116 224.441 13.0179C225.488 14.4987 226.012 16.0178 226.012 17.5752C226.012 17.805 225.922 18.0092 225.744 18.1879C225.59 18.3411 225.399 18.4177 225.169 18.4177H216.897C216.335 18.4177 215.889 18.0858 215.557 17.422C215.199 16.7071 214.765 16.171 214.255 15.8136C213.744 15.4561 212.953 15.2774 211.88 15.2774C210.68 15.2774 209.723 15.5582 209.008 16.1199C208.319 16.6816 207.974 17.4858 207.974 18.5326V24.66ZM256.787 8.19259C257.068 8.19259 257.31 8.29471 257.514 8.49896C257.719 8.70321 257.821 8.94575 257.821 9.22659V33.966C257.821 34.2468 257.719 34.4894 257.514 34.6936C257.31 34.8979 257.068 35 256.787 35H248.898C248.617 35 248.374 34.8979 248.17 34.6936C247.966 34.4894 247.864 34.2468 247.864 33.966V25.8089H240.205V33.966C240.205 34.2468 240.102 34.4894 239.898 34.6936C239.694 34.8979 239.451 35 239.171 35H231.282C231.001 35 230.758 34.9106 230.554 34.7319C230.35 34.5277 230.248 34.2724 230.248 33.966V9.22659C230.248 8.94575 230.35 8.70321 230.554 8.49896C230.758 8.29471 231.001 8.19259 231.282 8.19259H239.171C239.451 8.19259 239.694 8.29471 239.898 8.49896C240.102 8.70321 240.205 8.94575 240.205 9.22659V17.0773H247.864V9.22659C247.864 8.94575 247.966 8.70321 248.17 8.49896C248.374 8.29471 248.617 8.19259 248.898 8.19259H256.787Z" fill="white"/>
</svg>

            </Link>
            {isOpen ? (
              <div className="header__content__nav">
                {megaMenuListUpdated.map((item) => (
                  <Link
                    key={item.title}
                    to={item.link}
                    className={
                      isService
                        ? "header__content__nav__link header__content__nav__link__active"
                        : "header__content__nav__link"
                    }
                    onClick={() => handleOnClick(item.title)}
                    onMouseOver={() => handleOnHover(item.title)}
                  >
                    {item.title}
                  </Link>
                ))}
                <div className="mobilemenu">
                  {/* <Link
                    className={`header__content__nav__top__left__link ${
                      isService
                        ? "header__content__nav__top__left__link__active"
                        : ""
                    }`}
                    onClick={() => {
                      if (window.innerWidth < 1060) {
                        setIsOpen(false);
                      }
                    }}
                    to="/register?role=End-Customer"
                  >
                    Registration
                  </Link>
                  <Link
                    className={`header__content__nav__top__left__link ${
                      isService
                        ? "header__content__nav__top__left__link__active"
                        : ""
                    }`}
                    to="/careers"
                    onClick={() => {
                      if (window.innerWidth < 1060) {
                        setIsOpen(false);
                      }
                    }}
                  >
                    Careers
                  </Link> */}
                </div>
                <div className="header__content__nav__linkbtn__div">
                  <button
                    title="Request a Sample"
                    className="header__content__nav__linkbtn"
                
                  >
                    Contact us
                  </button>
                </div>
              </div>
            ) : null}
            <div className="header__content__cta">
              <button
                className="header__content__menu"
                onClick={() => setIsOpen(!isOpen)}
                title={isOpen ? "Close" : "Open"}
              >
                {isOpen ? (
                  <X size={20} color="currentColor" />
                ) : (
                  <Menu size={20} color="currentColor" />
                )}
              </button>
            </div>
          </div>
        </div>
        {isService ? (
          <MegaMenu
            onClickAway={() => {
              setIsService(false);
            }}
            data={
              megaMenuListUpdated.find((item) => item.title === serviceName)
                .children
            }
          />
        ) : null}
        {isOpen && window.innerWidth <= 1060 ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              width: "100%",
              height: "100vh",
              zIndex: 888,
            }}
            onClick={() => {
              setIsOpen(false);
            }}
          />
        ) : null}
        {popupVisible && (
          <ClickAwayListener onClickAway={() => setPopupVisible(false)}>
            <div className="popup">
              <div className="popup-content">
                <div className="text___button__popup">
                  <div className="text___button__popup__heading">Enquiry</div>
                  <button
                    type="button"
                    title="Close"
                    className="close-button"
                    onClick={() => setPopupVisible(false)}
                  >
                    X
                  </button>
                </div>
                <form
                  ref={form}
                  onSubmit={sendEmail}
                  className="contact__content__left__popup contact__content__left__reverse"
                >
                  <Input
                    id="name"
                    type="name"
                    label="Name"
                    name="name"
                    title="Name"
                    required={true}
                    onChange={handleNameChange}
                    error={nameError}
                  />
                  <Input
                    type="title"
                    name="title"
                    label="Title / Position"
                    title="Position"
                    required={true}
                    onChange={handleTitleChange}
                    error={titleError}
                  />
                  <Selectt
                    label="Flavor"
                    type="Flavor"
                    title="Flavor"
                    name="Flavor"
                    placeholder=" Select Flavor"
                    options={[
                      {
                        value: "Powder Flavor - Plated Solutions",
                        label: "Powder Flavor - Plated Solutions",
                      },
                      {
                        value: "Powder Flavor - Encapsulated Solutions",
                        label: "Powder Flavor - Encapsulated Solutions",
                      },
                      {
                        value: "Liquid Flavor - Oil Soluble Solutions",
                        label: "Liquid Flavor - Oil Soluble Solutions",
                      },
                      {
                        value: "Liquid Flavor - Water Soluble Solutions",
                        label: "Liquid Flavor - Water Soluble Solutions",
                      },
                    ]}
                    onChange={handleFlavorChange}
                    error={flavorError}
                  />
                  <Selectt
                    label="Categories"
                    name="Categories"
                    title="Categories"
                    placeholder="Select Categories"
                    options={[
                      {
                        value: "Beverage",
                        label: "Beverage",
                      },
                      {
                        value: "Bakery",
                        label: "Bakery",
                      },
                      {
                        value: "Confectionery",
                        label: "Confectionery",
                      },
                      {
                        value: "Dairy",
                        label: "Dairy",
                      },
                      {
                        value: "Plant",
                        label: "Plant",
                      },
                      {
                        value: "Snacks",
                        label: "Snacks",
                      },
                      {
                        value: "Others",
                        label: "Others",
                      },
                    ]}
                    onChange={handleCategoriesChange}
                    error={categoryError}
                  />
                  <Input
                    type="Company"
                    label="Company"
                    title="Company"
                    name="Company"
                    required={true}
                    onChange={handleCompanyChange}
                    error={companyError}
                  />
                  <Input
                    type="Country"
                    label="Country"
                    title="Country"
                    name="Country"
                    required={true}
                    onChange={handleCountryChange}
                    error={countryError}
                  />
                  <Input
                    type="Email"
                    label="Email"
                    title="Email"
                    name="Email"
                    required={true}
                    onChange={handleEmailChange}
                    error={emailError}
                  />
                  <Input
                    type="tel"
                    name="tel"
                    label="Phone Number"
                    title="Phone"
                    required={true}
                    onChange={handlePhoneChange}
                    error={phoneError}
                  />
                  <button
                    type="submit"
                    value="Send"
                    title="Submit"
                    className="contact__content__left__button"
                  >
                    Request
                  </button>
                </form>
                <Modal
                  isOpen={isModalOpen}
                  contentLabel="Form Submission Status"
                >
                  <div
                    className={`modal-content ${isError ? "error" : "success"}`}
                  >
                    <img
                      loading="lazy"
alt="img"                      src={GifSend}
                      className="sendgif"
                    />
                    <h2>
                      {isError
                        ? "Error submitting the form."
                        : " We have received your request successfully. We will contact you soon."}
                    </h2>
                  </div>
                </Modal>
              </div>
            </div>
          </ClickAwayListener>
        )}
      </div>
    </>
  );
}

function Input({ textarea, required, label, error, list, ...props }) {
  return (
    <div className="contact__content__left__input">
      <label
        htmlFor={props.id}
        className="contact__content__left__input__label"
      >
        {label}
        {required ? <span>*</span> : null}
      </label>
      {textarea ? (
        <textarea
          {...props}
          cols="30"
          rows="10"
          className="contact__content__left__input__field"
          required={required}
          style={{ padding: "1em" }}
        />
      ) : (
        <input
          {...props}
          className="contact__content__left__input__field"
          required={required}
          list={label + "s"}
          id={label}
        />
      )}
      {error !== "" ? (
        <div className="contact__content__left__input__error">{error}</div>
      ) : null}
      {list ? (
        <datalist className="datalist" id={label + "s"}>
          {list.map((item, i) => (
            <option className="options" key={i} value={item} />
          ))}
        </datalist>
      ) : null}
    </div>
  );
}
function Selectt({ label, id, error, ...props }) {
  return (
    <div className="container__main__content__details__main__input">
      <label
        htmlFor={id}
        className="container__main__content__details__main__input__label"
      >
        {label}
      </label>
      <div className="container__main__content__listing__header__left__filter container__main__content__listing__header__left__filter__special">
        <ReactSelect
          {...props}
          styles={{
            control: (provided) => ({
              ...provided,
              backgroundColor: "transparent",
              padding: "0.25em 0",
              border: "1px solid black",
            }),
          }}
          theme={(theme) => ({
            ...theme,
            borderRadius: 5,

            colors: {
              ...theme.colors,
              primary75: "#4884B6",
              primary25: "#4884B65e",
              primary50: "#4884B65e",
              primary: "#4884B6",
            },
          })}
        />
      </div>
      {error && (
        <div className="container__main__content__details__main__input__error">
          {error}
        </div>
      )}
    </div>
  );
}
